import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const Mariage = () => {
   const { t } = useTranslation();
   const ceremonyContent = t('wedding.ceremony.content');
   const [ceremonyIntro, ...ceremonyRestParts] = ceremonyContent.split('\n\n');
   const ceremonyRest = ceremonyRestParts.join('\n\n');

   return (
      <Box sx={{ padding: '2rem' }}>
         <Box sx={{ marginBottom: 6, marginTop: 3 }} id="ceremonie">
            <Typography variant="h4" gutterBottom>
               {t('wedding.ceremony.title')}
            </Typography>
            <Typography paragraph>{ceremonyIntro}</Typography>
            <Typography paragraph sx={{ fontWeight: 700, color: 'warning.dark', mb: 1.5 }}>
               {t('wedding.ceremony.arrivalNotice')}
            </Typography>
            {ceremonyRest ? (
               <Typography paragraph sx={{ whiteSpace: 'pre-line' }}>
                  {ceremonyRest}
               </Typography>
            ) : null}
         </Box>

         <Box sx={{ marginBottom: 6 }} id="reception">
            <Typography variant="h4" gutterBottom>
               {t('wedding.reception.title')}
            </Typography>
            <Typography paragraph>{t('wedding.reception.content')}</Typography>
            <Link href="https://g.co/kgs/53W9yFS" target="_blank" rel="noopener noreferrer">
               {t('wedding.viewmaps.content')}
            </Link>
            <Box sx={{ mt: 2 }}>
               <iframe
                  title="Carte Belvédère Pfingstberg"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11021.130352984426!2d13.052679403623175!3d52.41821038845643!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a8f6634b1afd0f%3A0xb2d2c855bd556ef7!2sBelvedere%20Castle%20on%20the%20Pfingstberg!5e0!3m2!1sen!2sde!4v1751392676176!5m2!1sen!2sde"
                  width="100%"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
               ></iframe>
            </Box>
         </Box>
      </Box>
   );
};
